import React from "react";

import {useParams, Outlet} from "react-router";
import Page from "components/Page";
import {i18n} from 'translate/i18n'
import FormTable from "./Form/form-table";
import {TagsProvider} from "store/providers/tags";
import FormMetas from "./Form/form-metas";

const Workflow = () => {

    let {param, id} = useParams();

    return (
        <TagsProvider>
            <Page
                label={`${i18n.t('titlePage.workflow')} / ${param === 'indicators' ? i18n.t('titlePage.indicators') : i18n.t('titlePage.goals')}`}
                icon="bi bi-diagram-3"
            >
                <Outlet/>

                {id &&
                    <>
                        <ul className="nav nav-tabs mt-3 border-bottom-0" id="myTab" role="tablist">
                            <li className="nav-item mt-2" role="presentation">
                                <button className="nav-link border-0 shadow-sm active" id="indicator-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#indicator" type="button" role="tab" aria-controls="indicator"
                                        aria-selected="true">{i18n.t('titlePage.indicator')}
                                </button>
                            </li>
                            <li className="nav-item mt-2" role="presentation">
                                <button className="nav-link border-0 shadow-sm" id="table-tab"
                                        data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop"
                                        aria-controls="offcanvasTop">Tabelas
                                </button>
                            </li>
                        </ul>

                        <div className="card rounded-0 rounded-bottom border-0 shadow-sm">
                            <div className="card-body p-0">
                                <div className="tab-content" id="myTabContent">
                                    <div className="tab-pane fade show active p-0" id="indicator" role="tabpanel"
                                         aria-labelledby="indicator-tab">
                                        <FormMetas />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="offcanvas offcanvas-top h-100" tabIndex="-1" id="offcanvasTop"
                             aria-labelledby="offCanvasCharts">
                            <div className="offcanvas-header bg-primary">
                                <h5 id="offCanvasCharts"
                                    className="text-uppercase mt-1">Tabelas</h5>
                                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"
                                        aria-label="Close"/>
                            </div>
                            <div className="offcanvas-body">
                                <FormTable/>
                            </div>
                        </div>
                    </>
                }
            </Page>
        </TagsProvider>
    );
}

export default Workflow
